<template>
    <div class="component">
        <vue-headful
        title="Add theme | W&S Docs"
        />
        <div v-if="loading" class="loading">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

        <div v-if="result" class="alert alert-secondary text-success font-weight-bold" role="alert">
            Тема успешно добавлена!
        </div>

        <div class="form-group">
            <router-link class="btn bg-dark text-white" to="/admin/themes">Вернуться назад</router-link>
        </div>
        <div class="form-group">
            <label for="title">Введите название</label>
            <input id="title" type="text" class="form-control bg-dark text-white" placeholder="Введите название"
            v-model="title"/>
        </div>
        <div class="form-group">
            <label for="link">Введите краткий адрес</label>
            <input id="link" type="text" class="form-control bg-dark text-white" placeholder="Введите краткий адрес"
            v-model="link"/>
            <small class="form-text text-muted">Например: user.get</small>
        </div>
        <div class="form-group">
            <label for="desc">Введите описание</label>
            <input id="desc" type="text" class="form-control bg-dark text-white" placeholder="Введите название"
            v-model="desc"/>
        </div>
        <button class="btn btn-dark" id="submit_btn" @click="AddTheme()">Добавить тему</button>
    </div>
</template>

<script>
    export default {
        name: "themeAdd",
        data() {
            return {
                title: this.title,
                link: this.link,
                desc: this.desc,
                result: null,
                loading: true,
            };
        },
        computed: {
            ThemeErrorGet: function () {
                return this.$store.getters.ThemeErrorGet;
            },
            ThemeSuccessGet: function () {
                return this.$store.getters.ThemeSuccessGet;
            },
            AdminAuthInfoGet: function () {
                return this.$store.getters.AdminAuthInfoGet;
            },
        },
        methods: {
            AddTheme: function () {
                let AdminID = this.AdminAuthInfoGet.AdminID,
                AdminToken = this.AdminAuthInfoGet.AdminToken;
                this.$store.dispatch('ThemeAddAct', [this.title, this.link, this.desc, AdminID, AdminToken]);

                if (this.ThemeSuccessGet === true && this.ThemeErrorGet.length === 0) {
                  this.result = true;
                  this.title = this.link = this.desc = '';
              }
          },
      },
      mounted() {
        this.loading = false;
    },
}
</script>

<style>
</style>
